module.exports = __webpack_public_path__ + "img/22.252d995e.png";